import { FC, useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { LoginForm } from '@features/auth/login-form';
import { useAuth } from '@features/auth/hooks/useAuth';
import { getJWTTokens } from '@shared/libs/local-storage';
import { LoginVariables, login } from '@features/auth/api/login';
import { getRouteEvents } from '@shared/constants/router';
import { jwtDecode } from 'jwt-decode';

export const AuthPage: FC = () => {
  const { login: authLogin } = useAuth();
  const [authState] = useState(getJWTTokens());
  const navigate = useNavigate();

  const [errorMessage, setErrorMessage] = useState('');
  const [isLoading, setIsLoading] = useState(false);

  useEffect(() => {
    authState.accessToken && navigate(getRouteEvents());
  }, [authState, navigate]);

  const handleClick = async ({ email, password, captcha_token }: LoginVariables) => {
    setIsLoading(true);
    try {
      const result = await login({ email, password, captcha_token });
      const { group_name } = jwtDecode<{ group_name: string }>(result.access_token);
      authLogin(email, result.access_token, result.refresh_token, group_name);
      navigate('/');
    } catch (error) {
      setErrorMessage('Неверный логин или пароль');
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <LoginForm
      onSubmit={handleClick}
      errorMessage={errorMessage}
      onChange={() => setErrorMessage('')}
      isLoading={isLoading}
    />
  );
};
